import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import {
  handbookResourceType,
  tutorialStepResourceType,
} from "./tutorialStepResourceConsts";

export const tutorialStepIdentifierStruct = createIdentifierStruct(
  tutorialStepResourceType
);

export const handbookIdentifierStruct = createIdentifierStruct(
  handbookResourceType
);
